import { render, staticRenderFns } from "./active-value.vue?vue&type=template&id=27f11cb2&lang=pug"
import script from "./active-value.vue?vue&type=script&lang=js"
export * from "./active-value.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports